import { confluenceSessionStorageInstance as sessionStorage } from '@confluence/storage-manager/entry-points/storageInstance';
import { keys as localStorageKeys } from '@confluence/storage-manager/entry-points/LocalStorageKeys';

export const checkRevertFlag = (contentId: string) => {
	return sessionStorage?.getItem(localStorageKeys.EDITOR_REVERTED) === contentId;
};

export const addRevertFlag = (contentId: string) => {
	sessionStorage?.setItem(localStorageKeys.EDITOR_REVERTED, contentId);
};

export const removeRevertFlag = () => {
	sessionStorage?.removeItem(localStorageKeys.EDITOR_REVERTED);
};
